

<div class="container">
  <div class="search-section">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input pInputText type="text" [(ngModel)]="searchKey" placeholder="Search.." class="p-inputtext-sm" (keyup.enter)="searchSales()"/>
      <p-button icon="pi pi-search" (onClick)="searchSales()" [style]="{'margin': '5px', 'height': '35px', 'line-height': '50px'}" [raised]="true" [size]="'small'" severity="info"></p-button>
    </span>
  </div>
  <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true" severity="info" class="refresh-button"></p-button>
</div>
<p-table #dt1 [value]="result.salespersons" [scrollable]="true" scrollHeight="350px" styleClass="p-datatable-striped"
    responsiveLayout="scroll" class="w-full m-5 p-datatable-sm" [paginator]="true" [rows]="5"
    [globalFilterFields]="['salespersonCode', 'salespersonName']" selectionMode="single" [loading]="loader"
    (onRowSelect)="SelectOption($event.data)" [rowsPerPageOptions]="[5, 10, 20]" (onPage)="loadSalesperson($event)">

    <ng-template pTemplate="header">
        <tr>
            <th></th>
            <th>Salesperson Code</th>
            <th>Salesperson Name</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-salesperson>
        <tr (click)="SelectOption(salesperson)">
            <td><p-tableRadioButton [value]="salesperson"></p-tableRadioButton></td>
            <td>{{ salesperson.salespersonCode }}</td>
            <td>{{ salesperson.salespersonName }}</td>
        </tr>
     </ng-template>
</p-table>
